<template>
  <div class="content-box">
    <heardTotal  :BankObj="BankObj" :superviseType="4" :queryParamsData="noGoodsPledgedData"></heardTotal>
    <div class="content-bottom">
      <div class="left">
        <div class="list-title">
          <headerTitle title="监管单据列表"></headerTitle>
          <div class="tab">
            <div class="tab-item" v-for="item in tabList" :key="item.value" @click="changeTab(item.value)" :class="{ 'active-tab': item.value == activeTab }">{{ item.label }}</div>
          </div>
        </div>
        <div class="search-box">
          <el-input size="small" placeholder="输入客户名称/电话号码检索" v-model="searchValue">
            <template slot="append">
              <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
            </template>
          </el-input>
        </div>
        <div class="item-box" @scroll="getLoad">
            <div class="item" v-for="item in list" :key="item.superviseId" @click="handleClickList(item)" :class="{ 'active-item': item.superviseId == activeList }">
            <div class="icon">
              <img v-if="item.id == activeList" src="../../../../assets/back/active-user-icon.png" alt="" />
              <img v-else src="../../../../assets/back/user-icon.png" alt="" />
            </div>
            <div class="user">
              <div>{{ item?.applyName }}</div>
              <div>授信金额：{{ item.superviseAmount }}万</div>
            </div>
            <div class="animal">可用金额： {{ item.superviseAmountReceive }}万</div>
          </div>
          <div class=loading style='display:block;text-align:center;height:30px;line-height:30px;color: #fff;padding: 10px;'>{{ stopLoding?'已加载全部内容':'加载中...' }}</div>
        </div>
      </div>
      <div class="center">
        <div class="center-top">
          <div class="grade-box">
            <div class="name">{{supInfo?.applyName }}</div>
            <div class="grade">
              风控评级：
              <span>A</span>
            </div>
          </div>
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="bg-purple">联系电话：{{ handelPhone }}</div>
            </el-col>
            <el-col :span="15">
              <div class="bg-purple">所在区域：宁夏-固原市-西吉县</div>
            </el-col>
          </el-row>
          <div class="supervise">
            <div class="supervise-box">
                <div>合同编号：{{ supInfo?.contractNo }}</div>
              <div>监管期限：{{supInfo?.superviseLimit||0}}个月({{(supInfo?.superviseStart||'')+'-'+(supInfo?.superviseEnd||'')}})</div>
              <div>客户经理：{{supInfo?.loanOfficerName}}</div>
              <div>用信金额：{{supInfo?.superviseAmount}}万</div>
            </div>
            <div class="supervise-icon">
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">3.90</div>
                  <div class="statis-value">待还金额(万)</div>
                </div>
                <div class="statis">
                  <div class="statis-icon">3.90</div>
                  <div class="statis-value">可用金额(万)</div>
                </div>
              </div>
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">3.90</div>
                  <div class="statis-value">监管库存总重(吨)</div>
                </div>
                <div class="statis">
                  <div class="statis-icon">3.90</div>
                  <div class="statis-value">采购订单(笔)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center-bottom">
          <headerTitle title="养殖经营概况" :sourceType="2"></headerTitle>
          <div class="tab-box">
            <div class="tab-item">
              <div class="tab-item-box" :class="{ 'tab-item-active ': item.id == activeOperate }" v-for="item in operateList" :key="item.id" @click="handleOper(item.id)">{{ item.label }}</div>
            </div>
            <div class="tab-date">
              <el-dropdown class="mydropdown" style="color: #fff; cursor: pointer" trigger="click" @command="handleDropmenu">
                <span class="el-dropdown-link"> {{ command || 2023 }}<i class="el-icon-caret-bottom el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in dropdownList" :command="item" :key="index">{{ item.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <livestockTrends ref="livestockTrendsRef" v-if="activeOperate == 1" :liveStockData="liveStockData"></livestockTrends>
          <forage v-else-if="activeOperate == 2"></forage>
          <operateTrends v-else-if="activeOperate == 3"></operateTrends>
        </div>
      </div>
      <div class="right">
        <div class="device">
        	<device :businessType="'4'" :businessId="businessId"></device>
        </div>
        <div class="inspection"></div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTitle from '@/views/bankScreen/components/headerTitle'
import livestockTrends from '@/views/bankScreen/branch/livestock/components/livestockTrends'
import forage from '@/views/bankScreen/branch/livestock/components/forage'
import operateTrends from '@/views/bankScreen/branch/livestock/components/operateTrends'
import heardTotal from '../components/heardTotal.vue'
import device from '@/views/bankScreen/components/device'
import{ Desensitized} from '@/utils/desensitization.js'
export default {
  components: {
    headerTitle,
    livestockTrends,
    forage,
    operateTrends,
    heardTotal,
	device
  },
  props: {
    noGoodsPledgedData: {
      typeof: Object,
      default: () => {},
    },
    BankObj:{
        type:Object,
        default: () => {},
    },
  },
  data() {
    return {
      activeTab: 2,
      searchValue: '',
      tabList: [
        {
          label: '监管中',
          value: 2,
        },
        {
          label: '已结束',
          value: 3,
        },
      ],
      list: [],
      activeList: 1,
      activeOperate: 2,
      operateList: [
        {
          label: '活畜动态',
          id: 1,
        },
        {
          label: '饲草料使用',
          id: 2,
        },
        {
          label: '经营动态',
          id: 3,
        },
      ],
      command: '',
      dropdownList: [
        { name: '2021', id: 1 },
        { name: '2022', id: 2 },
        { name: '2023', id: 3 },
        { name: '2024', id: 4 },
      ],
      liveStockData: [],
	  businessId:'1749336767664939009',
      stopLoding:false,
      pageNum:1,
      supInfo:{},
      supInfoObj:{}
    }
  },
  watch:{
    'noGoodsPledgedData':{
        handler(){
            this.pageNum=1
           this.getList()
        },
        deep:true
    },
    'activeList':{
        handler(){
            this.getSupInfo()
        },
    },
  },
  computed:{
    handelPhone(){
        return Desensitized.desensitizedPhone(this.supInfo?.applyPhone)
    },
  },
  created() {
    this.getList()
    this.getLiveStock()
  },
  mounted() {},

  methods: {
    getList(){
        this.stopLoding=true
        this.$http({
            url: 'ffsapp-service/superviseProperty/queryBankSuperviseList',
			method: 'post',
            data:{
                companyTenantIds:Array.isArray(this.noGoodsPledgedData.companyTenantIds)?[...this.noGoodsPledgedData.companyTenantIds]:this.noGoodsPledgedData.companyTenantIds.split(','),
                appId:'2015',
                ancestorsAllQuery:this.noGoodsPledgedData.ancestorsAllQuery,
                companyBankType:this.noGoodsPledgedData.companyBankType,
                companyTenantId:this.noGoodsPledgedData.companyTenantId,
                superviseStatus:this.activeTab,
                pageNum:this.pageNum,
                pageSize:10,
                searchValue:this.searchValue,
                superviseType:4
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.stopLoding=false
                let list=res.data.result.list||[]
                let total=Number(res.data.result.total) 
                if(list.length<=0){
                    this.stopLoding=true
                    this.list=[]
                }
                if(this.pageNum==1){
                    this.list=list
                }else{
                    this.list=[...this.list,...list]
                }
                this.activeList=this.list?.[0]?.superviseId
                this.supInfo=this.list?.[0]
                if(this.list.length==total){
                    this.stopLoding=true
                }else{
                    this.pageNum++
                }
            }
        })
    },
        //查看详情
        getSupInfo(){
        this.$http({  
            url:'ffsapp-service/superviseProperty/queryBankSuperviseDeatil',
            data:{superviseId:this.activeList},
            method: 'post',
        }).then((res)=>{
            if(res.data.code==200){
                this.supInfoObj=res.data.result
            }
        })

    },
        //实现下拉加载
    getLoad(){
        let boxHeight=document.querySelector('.item-box').clientHeight
        let scrollHeight =document.querySelector('.item-box').scrollHeight
        let scrollTop =document.querySelector('.item-box').scrollTop
       if(scrollHeight<boxHeight+scrollTop+5){
            if(!this.stopLoding){
                this.getList()
            }
   
       }
    },
    changeTab(val) {
      this.activeTab = val
      this.pageNum=1
      this.list=[]
      this.getList()
    },
    handleSearch() {
        this.pageNum=1
        this.list=[]
        this.getList()
    },

    handleClickList(val) {
        this.activeList = val.superviseId
        this.supInfo=val
    },


    handleOper(val) {
      this.activeOperate = val
    },
    handleDropmenu(command) {
      console.log(command)
      this.command = command.name
      this.liveStockData = [20, 434, 202, 368, 280, 160, 330]
      this.$nextTick(() => {
        this.$refs.livestockTrendsRef.setChart()
      })
    },
    // 活畜动态
    getLiveStock() {
      const rawData = [
        [100, 302, 301, 334, 390, 330, 320],
        [320, 132, 101, 134, 90, 230, 210],
      ]
      const totalData = []
      for (let i = 0; i < rawData[0].length; ++i) {
        let sum = 0
        for (let j = 0; j < rawData.length; ++j) {
          sum += rawData[j][i]
        }
        totalData.push(sum)
      }
      this.liveStockData = totalData
      console.log(this.liveStockData)
    },
  },
}
</script>
<style>
.el-dropdown-menu {
  background: rgba(52, 39, 20, 1);;
  border: 1px solid rgba(239, 171, 68, 0.2);
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled) {
  color: rgba(181, 180, 178, 1);
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(239, 171, 68, 0.2);
  color: rgba(181, 180, 178, 1);
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
  /* background: rgba(239, 171, 68, 0.2); */
  border-bottom-color: rgba(239, 171, 68, 0.2);
}

.el-popper[x-placement^='bottom'] .popper__arrow {
  /* background: rgba(239, 171, 68, 0.2); */
  border-bottom-color: rgba(239, 171, 68, 0.2);
  top: -7px;
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
  /* background: rgba(239, 171, 68, 0.2) !important; */
  border-bottom-color: rgba(239, 171, 68, 0.2);
}
</style>
<style scoped lang="scss">
@import './index.scss';
</style>
